<script>
    import {
        getFormatDate,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let estimateDetails = {};

    $: isEstimateCancelled = estimateDetails.status == Number(9);

    const handleClickEncounterId = () => {
        const { patientEncounterId } = estimateDetails;

        goToURL(`/PatientEncounter/view/${patientEncounterId}/tab=billing`);
    };
</script>

<div class="flex justify-between">
    <div class="flex items-center gap-x-4">
        <p>
            <span class="font-bold">Quote ID:</span>
            {estimateDetails.id} for Encounter ID
            <span
                class="underline cursor-pointer hover:font-bold"
                on:click|preventDefault={handleClickEncounterId}
                >{estimateDetails.patientEncounterId}</span
            >, <span class="font-bold">Quote No.:</span>
            {estimateDetails.estimateNumber}
        </p>

        <p>
            <span class="font-bold">Due date:</span>
            {getFormatDate(estimateDetails.expireDate)}
        </p>

        {#if isEstimateCancelled}
            <div
                class="badge badge-warning py-4 cursor-default text-white font-extrabold tracking-[0.25rem]"
            >
                CANCELLED
            </div>
        {/if}
    </div>
</div>
